import { Box, Typography } from "@mui/material";
import useResponsive from "../hooks/useResponsive";
import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  const mdUp = useResponsive("up", "md");

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", minWidth: "100vw" }}>
      {/* iOS 26 Liquid Glass hero panel */}
      {mdUp && (
        <Box
          sx={{
            width: { md: "44%", lg: "48%" },
            flexShrink: 0,
            background: "linear-gradient(160deg, #1A8FFF 0%, #0055D4 55%, #003DAA 100%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
            p: 6,
          }}
        >
          {/* Liquid glass orbs */}
          <Box sx={{
            position: "absolute", width: 360, height: 360, borderRadius: "50%",
            background: "rgba(255,255,255,0.07)",
            backdropFilter: "blur(40px)",
            top: -80, left: -80,
          }} />
          <Box sx={{
            position: "absolute", width: 260, height: 260, borderRadius: "50%",
            background: "rgba(255,255,255,0.06)",
            backdropFilter: "blur(30px)",
            bottom: 60, right: -60,
          }} />
          <Box sx={{
            position: "absolute", width: 140, height: 140, borderRadius: "50%",
            background: "rgba(255,255,255,0.10)",
            backdropFilter: "blur(20px)",
            bottom: 200, left: 40,
          }} />

          {/* SFM wordmark */}
          <Box sx={{ position: "relative", textAlign: "center", zIndex: 1 }}>
            <Box sx={{
              width: 80, height: 80, borderRadius: "20px", mx: "auto", mb: 3,
              background: "rgba(255,255,255,0.18)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255,255,255,0.35)",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
            }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: "#fff", letterSpacing: -0.5 }}>
                SFM
              </Typography>
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: "#fff", mb: 1, letterSpacing: -0.5 }}>
              Shop Floor Mgmt
            </Typography>
            <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.75)", maxWidth: 300, lineHeight: 1.6 }}>
              End-to-end traceability for fabrication, quality, and shipping — built by A3 Assurance Inc.
            </Typography>
          </Box>
        </Box>
      )}

      {/* Form panel */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 3, sm: 6 },
          py: 6,
          background: "linear-gradient(145deg, #EEF2FF 0%, #F2F2F7 50%, #F0F4FF 100%)",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 420 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
